import { subYears } from 'date-fns';

export const VALIDATION_I18N_PATH = 'common.validation';
export const GENERIC_ERROR_RULE = 'generic';

const MIN_VALID_AGE = 4;
const MAX_VALID_AGE = 100;

export const OLDEST_VALID_DATE = subYears(new Date(), MAX_VALID_AGE);
export const YOUNGEST_VALID_DATE = subYears(new Date(), MIN_VALID_AGE);
